import React from 'react';
import PropTypes from 'prop-types';
import { withTranslation } from 'react-i18next';
import { Grid, Typography } from '@mui/material';
import { Accordion } from '@totalsoft/rocket-ui';
import { AccordionWrapper } from 'components/common/SurfaceStyles';
import DocumentScoringClassificationComponent from './DocumentScoringClassificationComponent';
import DocumentScoringGridSummary from './DocumentScoringGridSummary';
import DocumentScoringKnockoutCriteriaListContainer from './DocumentScoringKnockoutCriteriaListContainer';
import { withRights } from 'providers/RightsConsumer';
import { ScoringGridContainer } from '../styles/DocumentScoringStyles';
import DocumentScoringDimensionPeriodListContainer from './DocumentScoringDimensionPeriodListContainer';

export const DocumentScoringGridComponent = ({ 
  scoringGrid, 
  disabled, 
  t, 
  documentId, 
  siteId, 
  rights, 
  isHistory, 
  showModal,
  savingModal,
  savingIndicators,
  dimensionPeriods, 
  onImportFinancialIndicators,
  onOpenDimensionListModal,
  onCloseDimensionListModal,
  onSavePeriodDimensions
}) => {
  return (
    <>
        <ScoringGridContainer item xs={12}>
          {((scoringGrid.entityType === 'ASSET' && rights.scoringGridAssetRead) ||
            (scoringGrid.entityType === 'DOCPARTNER' && rights.scoringGridClientRead) ||
            (scoringGrid.entityType === 'DOCUMENT' && rights.scoringGridDocumentRead)) && (
            <Accordion
              defaultExpanded={true}
              title={<DocumentScoringGridSummary 
                scoringGrid={scoringGrid} 
                onImportFinancialIndicators={onImportFinancialIndicators} 
                onOpenDimensionListModal={onOpenDimensionListModal} 
                disabled={
                  disabled ||
                  isHistory ||
                  (scoringGrid.entityType === 'DOCUMENT' && !rights.scoringGridDocumentWrite) ||
                  (scoringGrid.entityType === 'DOCPARTNER' && !rights.scoringGridClientWrite) ||
                  (scoringGrid.entityType === 'ASSET' && !rights.scoringGridAssetWrite)
                }
                saving={savingModal || savingIndicators}
                rights={rights}
                />}
              content={
                <Grid container spacing={1}>
                  {scoringGrid.classifications.length > 0 ? (
                    <AccordionWrapper
                      defaultExpanded={true}
                      content={scoringGrid.classifications.map(sc => {
                        return {
                          title: sc.name,
                          content: (
                            <DocumentScoringClassificationComponent
                              documentId={documentId}
                              siteId={siteId}
                              documentScoringGridId={scoringGrid.documentScoringGridId}
                              engineScoringId={scoringGrid.scoringGridId}
                              disabled={
                                disabled ||
                                isHistory ||
                                (scoringGrid.entityType === 'DOCUMENT' && !rights.scoringGridDocumentWrite) ||
                                (scoringGrid.entityType === 'DOCPARTNER' && !rights.scoringGridClientWrite) ||
                                (scoringGrid.entityType === 'ASSET' && !rights.scoringGridAssetWrite)
                              }
                              scoringClassification={sc}
                              indicatorPeriodList={scoringGrid.financialIndicatorPeriodDimensions || []}
                              entityType={scoringGrid.entityType}
                              isHistory={isHistory}
                              viewScoringDetailLimits={rights.viewScoringDetailLimits || false}
                              scoringGridCategoryScoreRead={rights.scoringGridCategoryScoreRead || false}
                            />
                          ),
                          defaultExpanded: true
                        };
                      })}
                    />
                  ) : (
                    ''
                  )}
                </Grid>
              }
            />
          )}
          {['DOCUMENT', 'DOCPARTNER'].includes(scoringGrid.entityType) &&
            rights.scoringKoRead &&
            scoringGrid.knockoutCriteria &&
            scoringGrid.knockoutCriteria.length > 0 && (
              <Accordion
                defaultExpanded={true}
                title={<Typography variant='h6'>{t('DocumentEdit.Scoring.ScoringGrid.KnockoutCriteria')}</Typography>}
                content={
                  <Grid container spacing={1}>
                    <DocumentScoringKnockoutCriteriaListContainer
                      documentId={documentId}
                      siteId={siteId}
                      documentScoringGridId={scoringGrid.documentScoringGridId}
                      knockoutCriteriaList={scoringGrid.knockoutCriteria}
                      disabled={disabled || isHistory || !rights.scoringKoWrite}
                      isHistory={isHistory}
                      fromPartner={false}
                    />
                  </Grid>
                }
              />
            )}
        </ScoringGridContainer>

      <DocumentScoringDimensionPeriodListContainer
        showModal={showModal}
        savingModal={savingModal}
        onCloseDimensionListModal={onCloseDimensionListModal}
        dimensions={dimensionPeriods}
        periods={scoringGrid.financialIndicatorPeriodDimensions || []}
        onSavePeriodDimensions={onSavePeriodDimensions}
        documentScoringGridId={scoringGrid.documentScoringGridId}
        />
    </>
  );
};

DocumentScoringGridComponent.propTypes = {
  documentId: PropTypes.number.isRequired,
  siteId: PropTypes.number.isRequired,
  scoringGrid: PropTypes.object.isRequired,
  t: PropTypes.func.isRequired,
  rights: PropTypes.object.isRequired,
  isHistory: PropTypes.bool,
  dimensionPeriods: PropTypes.array,
  disabled: PropTypes.bool,
  showModal: PropTypes.bool,
  savingModal: PropTypes.bool,
  savingIndicators: PropTypes.bool,
  onImportFinancialIndicators: PropTypes.func,
  onOpenDimensionListModal: PropTypes.func,
  onCloseDimensionListModal: PropTypes.func,
  onSavePeriodDimensions: PropTypes.func
};

export default withTranslation()(withRights(DocumentScoringGridComponent));
